import { observer } from "mobx-react-lite";

import {
  BaseMinimapSectionItem,
  type MinimapSectionItemProps,
} from "./BaseMinimapSectionItem";

export const RegularMinimapSectionItem = observer(
  function RegularMinimapSectionItem(props: MinimapSectionItemProps) {
    return <BaseMinimapSectionItem {...props} />;
  },
);
